import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { Observable, Subscription } from 'rxjs';
import { Article } from '../../../../models/article.model';
import { InitialsPipe } from '../../../../pipes/initials.pipe';
import { MomentPipe } from '../../../../pipes/moment.pipe';
import { AuthService } from '../../../../services/auth.service';
import * as articleActions from '../../../../state/actions/article.actions';
import { AppState } from '../../../../state/appstate';
import * as articleSelector from '../../../../state/selectors/article.selector';

@Component({
  selector: 'app-my-articles',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    NgxSkeletonLoaderModule,
    MomentPipe,
    InitialsPipe,
  ],
  templateUrl: './my-articles.component.html',
  styleUrls: ['./my-articles.component.css'],
})
export class MyArticlesComponent implements OnInit, OnDestroy {
  articles$: Observable<Article[]> = new Observable();

  articleState$: Subscription | undefined;

  loading: boolean = true;

  constructor(
    private store: Store<AppState>,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.articleState$ = this.store
      .select((state) => state.articles)
      .subscribe((articles) => {
        this.loading = articles.loading;
        if (articles.ids.length == 0 && !articles.loaded && !articles.loading) {
          const uid: string | undefined = this.authService.getUid();
          if (uid)
            this.store.dispatch(articleActions.getArticles({ uid: uid! }));
        }
      });
    this.articles$ = this.store.pipe(select(articleSelector.getAllArticles));
  }

  ngOnDestroy(): void {
    this.articleState$?.unsubscribe();
  }
}
